/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-16 16:19:46
 * @modify date 2023-11-16 16:19:46
 * @desc [description]
 */

import { View, ViewStyle, Text, TextStyle, StyleSheet } from "react-native"



interface CustomTextProps {
  style?: ViewStyle
  text: string;
  fontStyle: TextStyle;
  asterisk: boolean;
}



export default function CustomText(props:CustomTextProps) {
  return (
    // <View style={props.style}>
    <View>
      {
        (props.asterisk)
        ? <Text style={props.fontStyle}>
            <Text style={props.fontStyle}>{props.text}</Text>
            <Text style={style.starStyle}>{' *'}</Text>
        </Text>
        : <Text style={props.fontStyle}>{props.text}</Text>
      }
    </View>
  )
}



const style = StyleSheet.create({
  starStyle: {
    fontSize: 14,
    lineHeight: 14,
    color: '#ff0000'
  }
});